module.exports = __webpack_public_path__ + "officialStatic/img/pf4.1f76638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/pf4.png
// module id = D/fp
// module chunks = 0